import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { RxPencil1 } from "react-icons/rx";
import { MdDeleteOutline } from "react-icons/md";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { showToast } from "src/utils/showToaster";
import TeamResourceListing from "./TeamResourceListing";
import AddTeamResourceFormWrapper from "../add/AddTeamResourceFormWrapper";
import EditTeamResourceFormWrapper from "../Edit/EditTeamResourceFormWrapper";
import {
  useDeleteTeamResourceMutation,
  useGetTeamResourcesQuery,
} from "src/services/TeamResourceService";
import {
  setIsTableLoading,
  setItems,
  setRowsPerPage,
  setTotalItems,
  setSearchValue,
  setPage
} from "src/redux/slices/TeamResourcesSlice";

type Props = {};

const TeamResourceListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const [isOpenAddForm, setIsOpenAddForm] = useState(false);
  const [isOpenEditForm, setIsOpenEditForm] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  const [deleteTeamResource] = useDeleteTeamResourceMutation();
  
  const { totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.teamResourcesSlice);
  const {
    data: teamResourceData,
    isLoading,
    isFetching,
  } = useGetTeamResourcesQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["title"],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });
    const getActionOptions = (resourceId: string) => {
      
      return [
        {
          label: (
            <div className="flex items-center gap-2 text-secondary-main">
              <RxPencil1 className="text-lg" /> Edit
            </div>
          ),
          onClick: () => {
            setSelectedId(resourceId);
            setIsOpenEditForm(true);
          },
          // actionName: UserModuleActionTypes.EDIT,
          // moduleName: UserModuleNameTypes.RESOURCE,
        },
        {
          label: (
            <div className="flex items-center gap-2 font-semibold text-red-600">
              <MdDeleteOutline className="text-lg" /> Delete
            </div>
          ),
          onClick: () => {
            showConfirmationDialog({
              title: "Heads Up",
              text: "Are you sure want to Delete this Resource ?",
              icon: "question",
              showCancelButton: true,
              next: (result) => {
                if (result?.isConfirmed) {
                  deleteTeamResource({ Id: resourceId }).then((res: any) => {
                    if (res?.error) {
                      showToast("error", res?.error?.data?.message);
                    } else {
                      if (res?.data?.status) {
                        showToast("success", res?.data?.message);
                      } else {
                        showToast("error", res?.data?.message);
                      }
                    }
                  });
                }
              },
            });
          },
          // actionName: UserModuleActionTypes.DELETE,
          // moduleName: UserModuleNameTypes.RESOURCE,
        },
      ];
      
    };

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(teamResourceData?.data || []));
      dispatch(setTotalItems(teamResourceData?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamResourceData, isLoading, isFetching]);

  return (
    <div>
      <TeamResourceListing
        rows={teamResourceData?.data as any[]}
        getActionOptions={getActionOptions}
        onAddNew={() => {
          setIsOpenAddForm(true);
        }}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
      {isOpenAddForm && (
        <AddTeamResourceFormWrapper
          onClose={() => {
            setIsOpenAddForm(false);
          }}
        />
      )}
      {isOpenEditForm && (
        <EditTeamResourceFormWrapper
        id={selectedId}
          onClose={() => {
            setIsOpenEditForm(false);
          }}
        />
      )}
    </div>
  );
};

export default TeamResourceListingWrapper;
